export default __webpack_public_path__ + "static/27001-87091f6fc0eb7063fb131c05864c760e.png";